export const translations = {
  fi: {
    translation: {
      // Common
      app_name: "Reserve",
      loading: "Ladataan...",
      save: "Tallenna",
      cancel: "Peruuta",
      edit: "Muokkaa",
      delete: "Poista",
      back: "Takaisin",
      next: "Seuraava",
      done: "Valmis",
      search: "Hae",
      filter: "Suodata",
      close: "Sulje",
      add: "Lisää",
      optional: "valinnainen",
      name: "Nimi",
      version: "Versio",
      all_rights_reserved: "Kaikki oikeudet pidätetään.",
      settings_updated: "Asetukset päivitetty",
      fill_required_fields: "Täytä kaikki pakolliset kentät",
      
      // Auth
      login: "Kirjaudu",
      login_as_consumer: "Kirjaudu kuluttajana",
      login_as_business: "Kirjaudu yrityksenä",
      register: "Rekisteröidy",
      email: "Sähköposti",
      password: "Salasana",
      confirm_password: "Vahvista salasana",
      forgot_password: "Unohditko salasanan?",
      reset_password_title: "Palauta salasana",
      reset_password_desc: "Syötä sähköpostiosoitteesi, niin lähetämme sinulle linkin salasanan vaihtamiseen.",
      send_reset_link: "Lähetä palautuslinkki",
      reset_email_sent: "Palautuslinkki lähetetty sähköpostiisi!",
      reset_email_error: "Virhe salasanan palautuksessa. Tarkista sähköpostiosoite.",
      enter_email: "Syötä sähköpostiosoite",
      no_account: "Ei tiliä?",
      have_account: "Onko jo tili?",
      create_account: "Luo tili",
      change_password: "Vaihda salasana",
      
      // User types
      consumer: "Kuluttaja",
      business: "Yritys",
      select_user_type: "Valitse käyttäjätyyppi",
      consumer_desc: "Etsi palveluita ja tee varauksia",
      business_desc: "Tarjoa palveluita ja vastaanota varauksia",
      
      // Navigation
      nav_home: "Koti",
      nav_discover: "Selaa",
      nav_profile: "Profiili",
      nav_bookings: "Varaukset",
      nav_settings: "Asetukset",
      
      // Home
      welcome: "Tervetuloa",
      welcome_subtitle: "Varaa nopeasti – palvelu ovellesi hetkessä",
      business_welcome_subtitle: "Kasvata liiketoimintaasi kanssamme",
      featured_services: "Suositut palvelut",
      how_it_works: "Näin helppoa se on",
      step_1_title: "Valitse palvelu",
      step_1_desc: "Selaa kategorioita ja löydä sopiva palvelu sekunneissa",
      step_2_title: "Varaa heti",
      step_2_desc: "Valitse sopiva aika – varaus vie alle minuutin",
      step_3_title: "Valmista!",
      step_3_desc: "Ammattilainen tulee luoksesi sovittuna aikana",
      
      // Business Home
      why_use_app: "Miksi käyttää Reserveä?",
      benefit_customers_title: "Tavoita uudet asiakkaat",
      benefit_customers_desc: "Tuo palvelusi näkyville ja löydä uusia asiakkaita helposti",
      benefit_bookings_title: "Automaattiset varaukset",
      benefit_bookings_desc: "Varaukset tulevat suoraan kalenteriisi ilman ylimääräistä työtä",
      benefit_growth_title: "Kasvata liiketoimintaa",
      benefit_growth_desc: "Tavoita uusia asiakkaita ja kasvata liiketoimintaasi",
      benefit_time_title: "Säästä aikaa",
      benefit_time_desc: "Ei enää puhelimeen vastaamista - kaikki tapahtuu automaattisesti",
      stat_businesses: "Lisää asiakkaita",
      stat_bookings: "Enemmän näkyvyyttä",
      stat_rating: "Helppoja varauksia",
      quick_actions: "Pikatoiminnot",
      manage_profile: "Hallinnoi profiilia",
      edit_profile: "Muokkaa profiilia",
      view_bookings: "Näytä varaukset",
      
      // Discovery
      discover_title: "Pikavaraus",
      no_businesses: "Ei palveluntarjoajia saatavilla",
      swipe_up: "Pyyhkäise ylös nähdäksesi lisää",
      book_now: "Varaa heti",
      view_calendar: "Näytä vapaat ajat",
      available: "Vapaana nyt",
      select_category: "Mitä tarvitset?",
      select_category_description: "Valitse palvelukategoria ja varaa hetkessä",
      
      // Services/Categories
      all_services: "Kaikki palvelut",
      cleaning: "Siivous",
      snow_removal: "Lumityöt",
      window_cleaning: "Ikkunanpesu",
      gardening: "Puutarhatyöt",
      moving: "Muuttopalvelu",
      handyman: "Remonttityöt",
      other_service: "Muu palvelu",
      custom_service_type: "Oma palvelutyyppi",
      custom_service_type_placeholder: "Kirjoita oma palvelutyyppi...",
      
      // Business Profile
      business_profile: "Yritysprofiili",
      company_name: "Yrityksen nimi",
      company_name_placeholder: "Yritys Oy",
      description: "Kuvaus",
      business_description_placeholder: "Kerro yrityksestäsi ja mitä palveluita tarjoatte...",
      services_offered: "Tarjottavat palvelut",
      add_service: "Lisää palvelu",
      profile_image: "Profiilikuva",
      contact_info: "Yhteystiedot",
      contact_info_hint: "Lisää vähintään puhelin tai sähköposti",
      phone: "Puhelin",
      address: "Osoite",
      operating_area: "Toiminta-alue",
      operating_area_placeholder: "esim. Helsinki, Espoo",
      max_2_areas: "max 2",
      setup_business_profile: "Viimeistele yritysprofiilisi",
      setup_business_desc: "Täytä perustiedot yrityksestäsi päästäksesi sovellukseen",
      continue_to_app: "Jatka sovellukseen",
      basic_info: "Perustiedot",
      contact_email: "Yhteydenottosähköposti",
      
      // Service Profiles
      service_profiles: "Palveluprofiilit",
      create_service_profile: "Luo palveluprofiili",
      edit_service_profile: "Muokkaa palveluprofiilia",
      service_type: "Palvelutyyppi",
      service_title: "Palvelun otsikko",
      service_title_placeholder: "esim. Perusteellinen kodinsiivous",
      service_description: "Palvelun kuvaus",
      service_description_placeholder: "Kerro tarkemmin mitä palvelu sisältää...",
      price: "Hinta",
      duration: "Kesto",
      no_service_profiles: "Ei palveluprofiileja vielä",
      create_first_service: "Luo ensimmäinen palveluprofiili",
      service_created: "Palveluprofiili luotu",
      service_updated: "Palveluprofiili päivitetty",
      service_deleted: "Palveluprofiili poistettu",
      required_customer_fields_label: "Vaadittavat asiakastiedot",
      require_address: "Osoite",
      require_phone: "Puhelinnumero",
      require_email: "Sähköposti",
      
      // Calendar & Booking
      calendar: "Kalenteri",
      booking_calendar: "Varauskalenteri",
      select_date: "Valitse päivä",
      select_time: "Valitse aika",
      available_slots: "Vapaat ajat",
      booked: "Varattu",
      confirm_booking: "Vahvista varaus",
      booking_confirmed: "Varaus vahvistettu!",
      your_bookings: "Omat varaukset",
      upcoming_bookings: "Tulevat varaukset",
      past_bookings: "Menneet varaukset",
      no_bookings: "Ei varauksia",
      tap_to_toggle_availability: "Valitse päivä asettaaksesi vapaita aikoja",
      time_slots_available: "aikaväliä saatavilla",
      add_available_time: "Lisää vapaa aika",
      no_times_set: "Ei asetettuja aikoja tälle päivälle",
      confirm_changes: "Vahvista muutokset",
      cancel_booking: "Peruuta varaus",
      cancellation_reason: "Peruutuksen syy",
      cancellation_reason_placeholder: "Kerro miksi peruutat ajan...",
      rebook: "Varaa uusi aika",
      confirm_cancellation: "Vahvista peruutus",
      booking_cancelled: "Varaus peruutettu",
      free_times: "vapaata aikaa",
      cancelled: "Peruutettu",
      completed: "Suoritettu",
      rebook_confirmation_text: "Haluatko varata uuden ajan? Sinut ohjataan palveluiden selausosionn.",
      received_bookings: "Saapuneet varaukset",
      manage_customer_bookings: "Hallinnoi asiakkaiden varauksia",
      customer_info: "Asiakkaan tiedot",
      mark_completed: "Merkitse suoritetuksi",
      contact_customer: "Ota yhteyttä",
      booking_completed: "Varaus merkitty suoritetuksi",
      unknown: "Tuntematon",
      confirm_service: "Vahvista suoritetuksi",
      service_confirmed: "Palvelu vahvistettu suoritetuksi",
      
      // Reviews
      leave_review: "Jätä arvostelu",
      review_placeholder: "Kerro kokemuksestasi...",
      submit_review: "Lähetä arvostelu",
      review_submitted: "Arvostelu lähetetty",
      review_error: "Virhe arvostelun lähettämisessä",
      reviews: "Arvostelut",
      no_reviews: "Ei arvosteluja vielä",
      anonymous_customer: "Anonyymi asiakas",
      average_rating: "Keskiarvo",
      show_all_reviews: "Näytä kaikki arvostelut ({{count}})",
      business_calendar: "Varauskalenteri",
      bookings_for_day: "Varaukset päivälle",
      no_bookings_for_day: "Ei varauksia tälle päivälle",
      cannot_complete_yet: "Palvelun voi merkitä suoritetuksi vasta alkamisajan jälkeen",
      
      // Chat
      chat_greeting: "Hei! Kiitos yhteydenotosta. Miten voin auttaa tänään?",
      chat_auto_response: "Kiitos viestistäsi! Vastaamme sinulle mahdollisimman pian.",
      type_message: "Kirjoita viesti...",
      usually_responds_quickly: "Vastaa yleensä nopeasti",
      start_conversation: "Aloita keskustelu {{name}} kanssa lähettämällä viesti.",
      start_booking_conversation: "Aloita keskustelu tästä varauksesta",
      ask_about_booking: "Kysy palvelun yksityiskohdista tai muista varaukseen liittyvistä asioista.",
      message: "Viesti",
      
      // Image Upload
      current_image: "Nykyinen kuva",
      image_url: "Kuvan URL",
      choose_sample: "Tai valitse esimerkkikuva",
      image_updated: "Kuva päivitetty",
      upload_from_device: "Lataa kuva laitteelta",
      uploading: "Ladataan...",
      invalid_file_type: "Virheellinen tiedostotyyppi. Valitse kuvatiedosto.",
      file_too_large: "Tiedosto on liian suuri (max 5 MB)",
      upload_error: "Kuvan lataus epäonnistui",
      crop_image: "Rajaa kuva",
      zoom: "Lähennä",
      confirm: "Vahvista",
      
      // Categories
      add_new_category: "Lisää uusi kategoria",
      new_category_placeholder: "Kategorian nimi...",
      category_created: "Kategoria luotu",
      category_exists: "Kategoria on jo olemassa",
      
      // Settings
      settings: "Asetukset",
      account: "Tili",
      account_settings: "Tilin asetukset",
      language: "Kieli",
      notifications: "Ilmoitukset",
      privacy: "Yksityisyys",
      help: "Apua",
      about: "Tietoja",
      logout: "Kirjaudu ulos",
      delete_account: "Poista tili",
      confirm_logout_title: "Kirjaudu ulos",
      confirm_logout_desc: "Haluatko varmasti kirjautua ulos?",
      confirm_delete_title: "Poista tili",
      confirm_delete_desc: "Tämä toiminto on peruuttamaton. Kerro miksi haluat poistaa tilisi.",
      reason_too_expensive: "Liian kallis",
      reason_not_needed: "En tarvitse enää",
      reason_bad_experience: "Huono kokemus",
      reason_other: "Muu syy",
      delete_reason_placeholder: "Kerro tarkemmin...",
      account_deleted: "Tili poistettu",
      
      // Notifications settings
      push_notifications: "Push-ilmoitukset",
      push_notifications_desc: "Saat ilmoituksia puhelimeesi",
      email_notifications: "Sähköposti-ilmoitukset",
      email_notifications_desc: "Saat ilmoituksia sähköpostiisi",
      booking_reminders: "Varausmuistutukset",
      booking_reminders_desc: "Muistutus ennen varattua aikaa",
      message_notifications: "Viesti-ilmoitukset",
      message_notifications_desc: "Ilmoitus uusista viesteistä",
      
      // Privacy settings
      profile_visibility: "Profiilin näkyvyys",
      profile_visibility_desc: "Profiilisi näkyy muille käyttäjille",
      show_location: "Näytä sijainti",
      show_location_desc: "Sijaintisi näkyy profiilissasi",
      allow_messages: "Salli viestit",
      allow_messages_desc: "Muut voivat lähettää sinulle viestejä",
      
      // Help
      faq: "Usein kysytyt kysymykset",
      faq_desc: "Löydä vastauksia yleisimpiin kysymyksiin",
      live_chat: "Live-chat",
      live_chat_desc: "Keskustele asiakaspalvelun kanssa",
      email_support: "Sähköpostituki",
      email_support_desc: "reserve@app.fi",
      confirm_final_delete_title: "Oletko aivan varma?",
      confirm_final_delete_desc: "Tämä toiminto on peruuttamaton. Tilisi ja kaikki siihen liittyvät tiedot poistetaan pysyvästi.",
      confirm_delete_button: "Kyllä, poista tilini",
      account_delete_error: "Tilin poistaminen epäonnistui. Yritä uudelleen.",
      
      // About
      legal: "Oikeudelliset",
      terms_of_service: "Käyttöehdot",
      privacy_policy: "Tietosuojakäytäntö",
      
      // Terms acceptance
      accept_terms_title: "Hyväksy ehdot",
      accept_terms_desc: "Sinun on hyväksyttävä seuraavat ehdot jatkaaksesi.",
      accept_terms_checkbox: "Hyväksyn käyttöehdot",
      accept_privacy_checkbox: "Hyväksyn tietosuojakäytännön",
      accept_payment_terms_checkbox: "Hyväksyn maksuehdot",
      read_terms: "Lue käyttöehdot",
      read_privacy: "Lue tietosuojakäytäntö",
      read_payment_terms: "Lue maksuehdot",
      accept_and_continue: "Hyväksy ja jatka",
      
      // Booking required fields
      fill_booking_details: "Täytä vaadittavat tiedot",
      your_address: "Osoitteesi",
      your_phone: "Puhelinnumerosi",
      your_email: "Sähköpostisi",
      
      // Messages
      success: "Onnistui!",
      error: "Virhe",
      profile_updated: "Profiili päivitetty",
      booking_success: "Varaus onnistui",
      time_already_booked: "Tämä aika on jo varattu. Valitse toinen aika.",
      booking_error: "Varaus epäonnistui",
      
      // Messages page
      messages: "Viestit",
      no_messages: "Ei viestejä",
      no_messages_desc: "Keskustelusi palveluntarjoajien ja asiakkaiden kanssa näkyvät täällä.",
      service_messages: "Palveluviestit",
      general_messages: "Yleiset",
      no_service_messages_desc: "Palveluviestit näkyvät täällä kun sinulla on aktiivisia varauksia.",
      no_general_messages_desc: "Yleisiä viestejä ei ole vielä.",
      chat_closed: "Chat on suljettu",
      browse_without_login: "Selaa palveluita kirjautumatta",
      nav_messages: "Viestit",
      cancellation_error: "Peruutus epäonnistui",
      past_date_warning: "Menneille päiville ei voi lisätä aikoja",
      
      // Business Public Profile
      view_profile: "Näytä profiili",
      all_services_by: "Kaikki palvelut",
      business_info: "Yrityksen tiedot",
      services_count: "palvelua",
      no_services_available: "Ei palveluita saatavilla",
      no_messages_in_conversation: "Ei viestejä vielä tässä keskustelussa.",
      customer: "Asiakas",
      
      // Auth errors
      login_error: "Kirjautuminen epäonnistui. Tarkista sähköposti ja salasana.",
      register_error: "Rekisteröinti epäonnistui. Yritä uudelleen.",
      email_already_registered: "Sähköposti on jo rekisteröity.",
      registration_success: "Rekisteröinti onnistui! Tarkista sähköpostisi vahvistaaksesi tilin.",
      auth_error: "Tapahtui virhe. Yritä uudelleen.",
      
      // Subscription
      subscription_required_title: "Reserve Business -tilaus",
      subscription_required_desc: "Aloita 30 päivän ilmainen kokeilu",
      month: "kk",
      trial_info: "30 päivää ilmaiseksi",
      feature_unlimited_services: "Rajaton määrä palveluita",
      feature_calendar_management: "Kalenterinhallinta",
      feature_customer_messaging: "Asiakasviestintä",
      feature_booking_system: "Varausjärjestelmä",
      feature_analytics: "Analytiikka ja raportit",
      card_required_note: "Korttitiedot vaaditaan kokeilujakson aloittamiseen",
      start_trial: "Aloita ilmainen kokeilu",
      subscription_error: "Virhe tilauksen aloituksessa",
      subscription: "Tilaus",
      trial_active: "Kokeilujakso aktiivinen",
      subscription_active: "Tilaus aktiivinen",
      no_subscription: "Ei tilausta",
      admin_access: "Ylläpitäjän oikeudet",
      portal_error: "Virhe tilauksen hallinnassa",
      iframe_warning_title: "Huomio editori-esikatselussa",
      iframe_warning_desc: "Maksu avataan uuteen välilehteen. Kirjautumistila ei välttämättä säily välilehtien välillä. Suositus: avaa sovellus ensin uuteen välilehteen.",
      open_in_new_tab: "Avaa uuteen välilehteen",
      
      // Booking requests
      propose_time: "Ehdota aikaa",
      propose_time_desc: "Ehdota yritykselle haluamaasi aikaa. Yritys voi hyväksyä tai hylätä ehdotuksen.",
      proposed_time: "Ehdotettu aika",
      your_message: "Viestisi (valinnainen)",
      booking_requests: "Aikaehdotukset",
      pending_requests: "Odottavat ehdotukset",
      accept: "Hyväksy",
      reject: "Hylkää",
      rejection_reason: "Hylkäyksen syy",
      request_accepted: "Ehdotus hyväksytty",
      request_rejected: "Ehdotus hylätty",
      request_sent: "Aikaehdotus lähetetty",
      request_pending: "Odottaa",
      request_status_accepted: "Hyväksytty",
      request_status_rejected: "Hylätty",
      send: "Lähetä",
      no_requests: "Ei aikaehdotuksia",
      your_requests: "Lähettämäsi ehdotukset",
      
      // Calendar batch
      select_multiple_days: "Valitse useita päiviä",
      add_time_range: "Lisää aikavälillä",
      start_time: "Alkuaika",
      end_time: "Loppuaika",
      interval_minutes: "Väli (min)",
      clear_all_slots: "Tyhjennä kaikki ajat",
      add_range_to_selected: "Lisää ajat valituille päiville",
      selected_days: "valittua päivää",
      
      // Business registration
      business_registration_disabled: "Yritystilin luominen ei ole mahdollista rekisteröitymällä.",
      contact_for_business_account: "Ota yhteyttä reserve@app.fi yritystilin luomiseksi.",

      // Legal page titles
      consumer_terms_title: "Kuluttajan käyttöehdot",
      business_terms_title: "Yritysten käyttöehdot",
      consumer_privacy_title: "Kuluttajien tietosuoja",
      business_privacy_title: "Yritysten tietosuoja",

      // Consumer terms
      ct_platform_role_title: "1. Palvelun rooli",
      ct_platform_role_desc: "Alusta toimii vain välittäjänä kuluttajien ja palveluntarjoajien välillä. Alusta ei itse tarjoa palveluita eikä ole osapuoli palvelusopimuksessa.",
      ct_service_delivery_title: "2. Palveluiden toteutus",
      ct_service_delivery_desc: "Palveluntarjoajat ovat itsenäisiä toimijoita. Alusta ei vastaa palvelun laadusta, hinnoista tai lopputuloksesta.",
      ct_booking_title: "3. Varaaminen",
      ct_booking_desc: "Kuluttaja tekee varauksen suoraan palveluntarjoajalle alustan kautta. Mahdolliset peruutukset ja muutokset sovitaan palveluntarjoajan kanssa.",
      ct_liability_title: "4. Vastuunrajoitus",
      ct_liability_desc: "Alusta ei vastaa vahingoista, viivästyksistä tai riitatilanteista palveluntarjoajan ja kuluttajan välillä.",

      // Business terms
      bt_independent_operator_title: "1. Itsenäinen toimija",
      bt_independent_operator_desc: "Palveluntarjoaja toimii itsenäisenä yrittäjänä tai yksityisenä palveluntarjoajana. Alusta ei ole työnantaja, välittäjä tai toimeksiantaja.",
      bt_responsibility_title: "2. Vastuu toiminnasta",
      bt_responsibility_desc: "Palveluntarjoaja vastaa:",
      bt_responsibility_quality: "Palvelun sisällöstä ja laadusta",
      bt_responsibility_legality: "Lainmukaisuudesta",
      bt_responsibility_taxes: "Veroista ja kirjanpidosta",
      bt_responsibility_insurance: "Vakuutuksista",
      bt_customers_title: "3. Asiakkaat",
      bt_customers_desc: "Alusta ei takaa asiakasmäärää tai myyntiä. Alusta tarjoaa vain näkyvyyden ja varausalustan.",
      bt_account_removal_title: "4. Tilin poistaminen",
      bt_account_removal_desc: "Alustalla on oikeus poistaa palveluntarjoaja, joka rikkoo käyttöehtoja tai toimii lainvastaisesti.",

      // Privacy pages
      privacy_we_collect: "Keräämme",
      privacy_data_used_for: "Tietoja käytetään",
      privacy_collect_email: "Sähköpostin",
      privacy_collect_account: "Käyttäjätilin tiedot",
      privacy_collect_usage: "Sovelluksen käyttödataa",
      privacy_use_service: "Palvelun tarjoamiseen",
      privacy_use_communication: "Asiakasviestintään",
      privacy_use_development: "Palvelun kehittämiseen",
      privacy_no_sell: "Tietoja ei myydä kolmansille osapuolille.",
      privacy_collect_business_profile: "Yrityksen profiilitiedot",
      privacy_collect_contact: "Yhteystiedot",
      privacy_collect_technical: "Tekniset käyttödata",
      privacy_use_connections: "Asiakasyhteyksien mahdollistamiseen",
      privacy_use_billing: "Laskutukseen",

      // Complaints
      file_complaint: "Tee valitus",
      complaint_desc: "Jos yritys ei toteuttanut palvelua sovitusti, voit tehdä valituksen. Käsittelemme sen mahdollisimman pian.",
      complaint_placeholder: "Kerro mitä tapahtui ja miksi haluat tehdä valituksen...",
      send_complaint: "Lähetä valitus",
      complaint_sent: "Valitus lähetetty. Käsittelemme sen pian.",

      // District
      operating_district: "Kaupunginosa",
      operating_district_placeholder: "esim. Kallio, Töölö",

      // Availability types
      anytime: "Mikä vain aika",
      anytime_desc: "Asiakas voi ehdottaa minkä tahansa ajan",
      blocked: "Ei saatavilla",
      blocked_desc: "Päivä on estetty eikä varauksia voi tehdä",
      specific_times: "Tietyt ajat",
      select_date_range: "Valitse aikajakso",
      availability_type: "Saatavuustyyppi",
      choose_availability_or_times: "Valitse saatavuustyyppi tai lisää tietyt ajat alla",
      or: "tai",
      apply_to_range: "Sovella valittuihin päiviin",
      anytime_set_success: "Päivät asetettu: mikä vain aika sopii",
      blocked_set_success: "Päivät asetettu: ei saatavilla",
      propose_your_time: "Ehdota haluamasi aika",
      day_blocked: "Tämä päivä ei ole saatavilla",
      color_legend: "Väriselitykset",
      anytime_available: "Mikä vain aika sopii",
      specific_slots_available: "Tiettyjä aikoja",
      today_marker: "Tänään",
      unsaved_changes: "Tallentamattomia muutoksia",
      changes_saved: "Muutokset tallennettu",
      book_directly: "Varaa suoraan",
      selected_marker: "Valittu",
      no_slots_propose: "Ei vapaita aikoja – voit ehdottaa ajan",

      // Booking limits
      max_daily_bookings: "Varauksia päivässä enintään",
      buffer_minutes: "Tauko varausten välissä",
      pick_any_time: "Valitse mikä tahansa aika",
      day_full: "Päivä täynnä",
      bookings_remaining: "varausta jäljellä",
      no_limit: "Ei rajaa",

      // Password reset page
      set_new_password_title: "Aseta uusi salasana",
      set_new_password_desc: "Syötä uusi salasanasi alla.",
      new_password: "Uusi salasana",
      password_updated: "Salasana päivitetty onnistuneesti!",
      passwords_dont_match: "Salasanat eivät täsmää",
      password_update_error: "Salasanan päivitys epäonnistui",
      password_too_short: "Salasanan on oltava vähintään 6 merkkiä",
      back_to_login: "Takaisin kirjautumiseen",

      // Registration terms
      accept_terms_register: "Hyväksyn käyttöehdot",
      accept_privacy_register: "Hyväksyn tietosuojakäytännön",

      // Discovery tabs & business browse
      tab_services: "Palvelut",
      tab_businesses: "Yritykset",
      browse_businesses_title: "Selaa yrityksiä",
      browse_businesses_desc: "Tutustu yrityksiin ja niiden palveluihin",
      no_businesses_found: "Ei yrityksiä saatavilla",
      all_services_count: "{{count}} palvelua",
      send_message: "Lähetä viesti",
    }
  },
  en: {
    translation: {
      // Common
      app_name: "Reserve",
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      back: "Back",
      next: "Next",
      done: "Done",
      search: "Search",
      filter: "Filter",
      close: "Close",
      add: "Add",
      optional: "optional",
      name: "Name",
      version: "Version",
      all_rights_reserved: "All rights reserved.",
      settings_updated: "Settings updated",
      fill_required_fields: "Please fill all required fields",
      
      // Auth
      login: "Log in",
      login_as_consumer: "Log in as consumer",
      login_as_business: "Log in as business",
      register: "Register",
      email: "Email",
      password: "Password",
      confirm_password: "Confirm password",
      forgot_password: "Forgot password?",
      reset_password_title: "Reset password",
      reset_password_desc: "Enter your email address and we'll send you a link to reset your password.",
      send_reset_link: "Send reset link",
      reset_email_sent: "Reset link sent to your email!",
      reset_email_error: "Error resetting password. Check your email address.",
      enter_email: "Enter email address",
      no_account: "No account?",
      have_account: "Already have an account?",
      create_account: "Create account",
      change_password: "Change password",
      
      // User types
      consumer: "Consumer",
      business: "Business",
      select_user_type: "Select user type",
      consumer_desc: "Find services and make bookings",
      business_desc: "Offer services and receive bookings",
      
      // Navigation
      nav_home: "Home",
      nav_discover: "Discover",
      nav_profile: "Profile",
      nav_bookings: "Bookings",
      nav_settings: "Settings",
      
      // Home
      welcome: "Welcome",
      welcome_subtitle: "Book fast – service at your door in no time",
      business_welcome_subtitle: "Grow your business with us",
      featured_services: "Featured services",
      how_it_works: "It's this easy",
      step_1_title: "Pick a service",
      step_1_desc: "Browse categories and find what you need in seconds",
      step_2_title: "Book instantly",
      step_2_desc: "Choose a time – booking takes less than a minute",
      step_3_title: "Done!",
      step_3_desc: "The professional comes to you at the agreed time",
      
      // Business Home
      why_use_app: "Why use Reserve?",
      benefit_customers_title: "Reach new customers",
      benefit_customers_desc: "Make your services visible and find new customers easily",
      benefit_bookings_title: "Automatic bookings",
      benefit_bookings_desc: "Bookings go directly to your calendar without extra work",
      benefit_growth_title: "Grow your business",
      benefit_growth_desc: "Reach new customers and grow your business",
      benefit_time_title: "Save time",
      benefit_time_desc: "No more answering phones - everything happens automatically",
      stat_businesses: "More customers",
      stat_bookings: "More visibility",
      stat_rating: "Easy bookings",
      quick_actions: "Quick actions",
      manage_profile: "Manage profile",
      edit_profile: "Edit profile",
      view_bookings: "View bookings",
      
      // Discovery
      discover_title: "Quick Book",
      no_businesses: "No providers available",
      swipe_up: "Swipe up to see more",
      book_now: "Book now",
      view_calendar: "See availability",
      available: "Available now",
      select_category: "What do you need?",
      select_category_description: "Pick a category and book in seconds",
      
      // Services/Categories
      all_services: "All services",
      cleaning: "Cleaning",
      snow_removal: "Snow removal",
      window_cleaning: "Window cleaning",
      gardening: "Gardening",
      moving: "Moving service",
      handyman: "Handyman",
      other_service: "Other service",
      custom_service_type: "Custom service type",
      custom_service_type_placeholder: "Enter your own service type...",

      // Business Profile
      business_profile: "Business profile",
      company_name: "Company name",
      company_name_placeholder: "Company Ltd",
      description: "Description",
      business_description_placeholder: "Tell about your company and what services you offer...",
      services_offered: "Services offered",
      add_service: "Add service",
      profile_image: "Profile image",
      contact_info: "Contact info",
      contact_info_hint: "Add at least phone or email",
      phone: "Phone",
      address: "Address",
      operating_area: "Operating area",
      operating_area_placeholder: "e.g. Helsinki, Espoo",
      max_2_areas: "max 2",
      setup_business_profile: "Complete your business profile",
      setup_business_desc: "Fill in basic information about your business to access the app",
      continue_to_app: "Continue to app",
      basic_info: "Basic info",
      contact_email: "Contact email",
      
      // Service Profiles
      service_profiles: "Service profiles",
      create_service_profile: "Create service profile",
      edit_service_profile: "Edit service profile",
      service_type: "Service type",
      service_title: "Service title",
      service_title_placeholder: "e.g. Thorough home cleaning",
      service_description: "Service description",
      service_description_placeholder: "Describe in detail what the service includes...",
      price: "Price",
      duration: "Duration",
      no_service_profiles: "No service profiles yet",
      create_first_service: "Create your first service profile",
      service_created: "Service profile created",
      service_updated: "Service profile updated",
      service_deleted: "Service profile deleted",
      required_customer_fields_label: "Required customer information",
      require_address: "Address",
      require_phone: "Phone number",
      require_email: "Email",
      
      // Calendar & Booking
      calendar: "Calendar",
      booking_calendar: "Booking calendar",
      select_date: "Select date",
      select_time: "Select time",
      available_slots: "Available slots",
      booked: "Booked",
      confirm_booking: "Confirm booking",
      booking_confirmed: "Booking confirmed!",
      your_bookings: "Your bookings",
      upcoming_bookings: "Upcoming bookings",
      past_bookings: "Past bookings",
      no_bookings: "No bookings",
      tap_to_toggle_availability: "Select a day to set available times",
      time_slots_available: "time slots available",
      add_available_time: "Add available time",
      no_times_set: "No times set for this day",
      confirm_changes: "Confirm changes",
      cancel_booking: "Cancel booking",
      cancellation_reason: "Cancellation reason",
      cancellation_reason_placeholder: "Tell us why you are cancelling...",
      rebook: "Book new time",
      confirm_cancellation: "Confirm cancellation",
      booking_cancelled: "Booking cancelled",
      free_times: "free times",
      cancelled: "Cancelled",
      completed: "Completed",
      rebook_confirmation_text: "Would you like to book a new time? You will be redirected to the service discovery section.",
      received_bookings: "Received bookings",
      manage_customer_bookings: "Manage customer bookings",
      customer_info: "Customer info",
      mark_completed: "Mark completed",
      contact_customer: "Contact customer",
      booking_completed: "Booking marked as completed",
      unknown: "Unknown",
      confirm_service: "Confirm completed",
      service_confirmed: "Service confirmed as completed",
      
      // Reviews
      leave_review: "Leave a review",
      review_placeholder: "Tell about your experience...",
      submit_review: "Submit review",
      review_submitted: "Review submitted",
      review_error: "Error submitting review",
      reviews: "Reviews",
      no_reviews: "No reviews yet",
      anonymous_customer: "Anonymous customer",
      average_rating: "Average",
      show_all_reviews: "Show all reviews ({{count}})",
      business_calendar: "Booking Calendar",
      bookings_for_day: "Bookings for",
      no_bookings_for_day: "No bookings for this day",
      cannot_complete_yet: "Service can be marked completed only after the start time",
      
      // Chat
      chat_greeting: "Hello! Thank you for contacting us. How can I help you today?",
      chat_auto_response: "Thank you for your message! We'll get back to you as soon as possible.",
      type_message: "Type a message...",
      usually_responds_quickly: "Usually responds quickly",
      start_conversation: "Start a conversation with {{name}} by sending a message.",
      start_booking_conversation: "Start a conversation about this booking",
      ask_about_booking: "Ask about service details or other booking-related questions.",
      message: "Message",
      
      // Image Upload
      current_image: "Current image",
      image_url: "Image URL",
      choose_sample: "Or choose a sample image",
      image_updated: "Image updated",
      upload_from_device: "Upload from device",
      uploading: "Uploading...",
      invalid_file_type: "Invalid file type. Please select an image.",
      file_too_large: "File is too large (max 5 MB)",
      upload_error: "Image upload failed",
      crop_image: "Crop image",
      zoom: "Zoom",
      confirm: "Confirm",
      
      // Categories
      add_new_category: "Add new category",
      new_category_placeholder: "Category name...",
      category_created: "Category created",
      category_exists: "Category already exists",
      
      // Settings
      settings: "Settings",
      account: "Account",
      account_settings: "Account settings",
      language: "Language",
      notifications: "Notifications",
      privacy: "Privacy",
      help: "Help",
      about: "About",
      logout: "Log out",
      delete_account: "Delete account",
      confirm_logout_title: "Log out",
      confirm_logout_desc: "Are you sure you want to log out?",
      confirm_delete_title: "Delete account",
      confirm_delete_desc: "This action is irreversible. Please tell us why you want to delete your account.",
      reason_too_expensive: "Too expensive",
      reason_not_needed: "No longer needed",
      reason_bad_experience: "Bad experience",
      reason_other: "Other reason",
      delete_reason_placeholder: "Tell us more...",
      account_deleted: "Account deleted",
      
      // Notifications settings
      push_notifications: "Push notifications",
      push_notifications_desc: "Receive notifications on your phone",
      email_notifications: "Email notifications",
      email_notifications_desc: "Receive notifications via email",
      booking_reminders: "Booking reminders",
      booking_reminders_desc: "Reminder before your booked time",
      message_notifications: "Message notifications",
      message_notifications_desc: "Notification for new messages",
      
      // Privacy settings
      profile_visibility: "Profile visibility",
      profile_visibility_desc: "Your profile is visible to other users",
      show_location: "Show location",
      show_location_desc: "Your location is shown on your profile",
      allow_messages: "Allow messages",
      allow_messages_desc: "Others can send you messages",
      
      // Help
      faq: "Frequently asked questions",
      faq_desc: "Find answers to common questions",
      live_chat: "Live chat",
      live_chat_desc: "Chat with customer support",
      email_support: "Email support",
      email_support_desc: "reserve@app.fi",
      confirm_final_delete_title: "Are you absolutely sure?",
      confirm_final_delete_desc: "This action is irreversible. Your account and all associated data will be permanently deleted.",
      confirm_delete_button: "Yes, delete my account",
      account_delete_error: "Failed to delete account. Please try again.",
      
      // About
      legal: "Legal",
      terms_of_service: "Terms of service",
      privacy_policy: "Privacy policy",
      
      // Terms acceptance
      accept_terms_title: "Accept terms",
      accept_terms_desc: "You must accept the following terms to continue.",
      accept_terms_checkbox: "I accept the terms of service",
      accept_privacy_checkbox: "I accept the privacy policy",
      accept_payment_terms_checkbox: "I accept the payment terms",
      read_terms: "Read terms of service",
      read_privacy: "Read privacy policy",
      read_payment_terms: "Read payment terms",
      accept_and_continue: "Accept and continue",
      
      // Booking required fields
      fill_booking_details: "Fill in required details",
      your_address: "Your address",
      your_phone: "Your phone number",
      your_email: "Your email",
      
      // Messages
      success: "Success!",
      error: "Error",
      profile_updated: "Profile updated",
      booking_success: "Booking successful",
      time_already_booked: "This time is already booked. Please select another time.",
      booking_error: "Booking failed",
      
      // Messages page
      messages: "Messages",
      no_messages: "No messages",
      no_messages_desc: "Your conversations with service providers and customers will appear here.",
      service_messages: "Service messages",
      general_messages: "General",
      no_service_messages_desc: "Service messages will appear here when you have active bookings.",
      no_general_messages_desc: "No general messages yet.",
      chat_closed: "Chat is closed",
      browse_without_login: "Browse services without logging in",
      nav_messages: "Messages",
      cancellation_error: "Cancellation failed",
      past_date_warning: "Cannot add times to past dates",
      
      // Business Public Profile
      view_profile: "View profile",
      all_services_by: "All services",
      business_info: "Business info",
      services_count: "services",
      no_services_available: "No services available",
      no_messages_in_conversation: "No messages in this conversation yet.",
      customer: "Customer",
      
      // Auth errors
      login_error: "Login failed. Check your email and password.",
      register_error: "Registration failed. Please try again.",
      email_already_registered: "Email is already registered.",
      registration_success: "Registration successful! Check your email to verify your account.",
      auth_error: "An error occurred. Please try again.",
      
      // Subscription
      subscription_required_title: "Reserve Business Subscription",
      subscription_required_desc: "Start your 30-day free trial",
      month: "mo",
      trial_info: "30 days free",
      feature_unlimited_services: "Unlimited services",
      feature_calendar_management: "Calendar management",
      feature_customer_messaging: "Customer messaging",
      feature_booking_system: "Booking system",
      feature_analytics: "Analytics and reports",
      card_required_note: "Card details required to start trial",
      start_trial: "Start free trial",
      subscription_error: "Error starting subscription",
      subscription: "Subscription",
      trial_active: "Trial active",
      subscription_active: "Subscription active",
      no_subscription: "No subscription",
      admin_access: "Admin access",
      portal_error: "Error managing subscription",
      iframe_warning_title: "Note for editor preview",
      iframe_warning_desc: "Payment will open in a new tab. Login state may not persist between tabs. Recommendation: open the app in a new tab first.",
      open_in_new_tab: "Open in new tab",
      
      // Booking requests
      propose_time: "Propose a time",
      propose_time_desc: "Suggest your preferred time to the business. They can accept or decline.",
      proposed_time: "Proposed time",
      your_message: "Your message (optional)",
      booking_requests: "Time proposals",
      pending_requests: "Pending proposals",
      accept: "Accept",
      reject: "Reject",
      rejection_reason: "Rejection reason",
      request_accepted: "Proposal accepted",
      request_rejected: "Proposal rejected",
      request_sent: "Time proposal sent",
      request_pending: "Pending",
      request_status_accepted: "Accepted",
      request_status_rejected: "Rejected",
      send: "Send",
      no_requests: "No time proposals",
      your_requests: "Your proposals",
      
      // Calendar batch
      select_multiple_days: "Select multiple days",
      add_time_range: "Add time range",
      start_time: "Start time",
      end_time: "End time",
      interval_minutes: "Interval (min)",
      clear_all_slots: "Clear all slots",
      add_range_to_selected: "Add slots to selected days",
      selected_days: "days selected",
      
      // Business registration
      business_registration_disabled: "Business account creation is not available through registration.",
      contact_for_business_account: "Contact reserve@app.fi to create a business account.",

      // Legal page titles
      consumer_terms_title: "Consumer Terms of Service",
      business_terms_title: "Business Terms of Service",
      consumer_privacy_title: "Consumer Privacy Policy",
      business_privacy_title: "Business Privacy Policy",

      // Consumer terms
      ct_platform_role_title: "1. Role of the Platform",
      ct_platform_role_desc: "The platform acts solely as an intermediary between consumers and service providers. The platform does not provide services itself and is not a party to the service agreement.",
      ct_service_delivery_title: "2. Service Delivery",
      ct_service_delivery_desc: "Service providers are independent operators. The platform is not responsible for service quality, pricing, or outcomes.",
      ct_booking_title: "3. Booking",
      ct_booking_desc: "The consumer makes bookings directly with the service provider through the platform. Cancellations and changes are agreed upon with the service provider.",
      ct_liability_title: "4. Limitation of Liability",
      ct_liability_desc: "The platform is not liable for damages, delays, or disputes between the service provider and the consumer.",

      // Business terms
      bt_independent_operator_title: "1. Independent Operator",
      bt_independent_operator_desc: "The service provider operates as an independent entrepreneur or private service provider. The platform is not an employer, broker, or principal.",
      bt_responsibility_title: "2. Responsibility",
      bt_responsibility_desc: "The service provider is responsible for:",
      bt_responsibility_quality: "Service content and quality",
      bt_responsibility_legality: "Legal compliance",
      bt_responsibility_taxes: "Taxes and accounting",
      bt_responsibility_insurance: "Insurance",
      bt_customers_title: "3. Customers",
      bt_customers_desc: "The platform does not guarantee customer volume or sales. The platform only provides visibility and a booking platform.",
      bt_account_removal_title: "4. Account Removal",
      bt_account_removal_desc: "The platform reserves the right to remove a service provider that violates the terms of service or acts unlawfully.",

      // Privacy pages
      privacy_we_collect: "We Collect",
      privacy_data_used_for: "Data is Used For",
      privacy_collect_email: "Email address",
      privacy_collect_account: "User account information",
      privacy_collect_usage: "Application usage data",
      privacy_use_service: "Providing the service",
      privacy_use_communication: "Customer communication",
      privacy_use_development: "Service development",
      privacy_no_sell: "Data is not sold to third parties.",
      privacy_collect_business_profile: "Business profile information",
      privacy_collect_contact: "Contact information",
      privacy_collect_technical: "Technical usage data",
      privacy_use_connections: "Enabling customer connections",
      privacy_use_billing: "Billing",

      // Complaints
      file_complaint: "File complaint",
      complaint_desc: "If the business did not deliver the service as agreed, you can file a complaint. We will handle it as soon as possible.",
      complaint_placeholder: "Tell us what happened and why you want to file a complaint...",
      send_complaint: "Send complaint",
      complaint_sent: "Complaint sent. We will handle it soon.",

      // District
      operating_district: "District",
      operating_district_placeholder: "e.g. Kallio, Töölö",

      // Availability types
      anytime: "Any time",
      anytime_desc: "Customer can propose any time",
      blocked: "Unavailable",
      blocked_desc: "Day is blocked and no bookings can be made",
      specific_times: "Specific times",
      select_date_range: "Select date range",
      availability_type: "Availability type",
      choose_availability_or_times: "Choose an availability type or add specific times below",
      or: "or",
      apply_to_range: "Apply to selected days",
      anytime_set_success: "Days set: any time available",
      blocked_set_success: "Days set: unavailable",
      propose_your_time: "Propose your preferred time",
      day_blocked: "This day is not available",
      color_legend: "Color legend",
      anytime_available: "Any time available",
      specific_slots_available: "Specific times",
      today_marker: "Today",
      unsaved_changes: "Unsaved changes",
      changes_saved: "Changes saved",
      book_directly: "Book directly",
      selected_marker: "Selected",
      no_slots_propose: "No available times – you can propose a time",

      // Booking limits
      max_daily_bookings: "Max bookings per day",
      buffer_minutes: "Buffer between bookings",
      pick_any_time: "Pick any time",
      day_full: "Day full",
      bookings_remaining: "bookings remaining",
      no_limit: "No limit",

      // Password reset page
      set_new_password_title: "Set new password",
      set_new_password_desc: "Enter your new password below.",
      new_password: "New password",
      password_updated: "Password updated successfully!",
      passwords_dont_match: "Passwords don't match",
      password_update_error: "Failed to update password",
      password_too_short: "Password must be at least 6 characters",
      back_to_login: "Back to login",

      // Registration terms
      accept_terms_register: "I accept the terms of service",
      accept_privacy_register: "I accept the privacy policy",

      // Discovery tabs & business browse
      tab_services: "Services",
      tab_businesses: "Businesses",
      browse_businesses_title: "Browse businesses",
      browse_businesses_desc: "Explore businesses and their services",
      no_businesses_found: "No businesses available",
      all_services_count: "{{count}} services",
      send_message: "Send message",
    }
  },
  sv: {
    translation: {
      // Common
      app_name: "Reserve",
      loading: "Laddar...",
      save: "Spara",
      cancel: "Avbryt",
      edit: "Redigera",
      delete: "Radera",
      back: "Tillbaka",
      next: "Nästa",
      done: "Klar",
      search: "Sök",
      filter: "Filtrera",
      close: "Stäng",
      add: "Lägg till",
      optional: "valfritt",
      name: "Namn",
      version: "Version",
      all_rights_reserved: "Alla rättigheter förbehållna.",
      settings_updated: "Inställningar uppdaterade",
      fill_required_fields: "Fyll i alla obligatoriska fält",

      // Auth
      login: "Logga in",
      login_as_consumer: "Logga in som konsument",
      login_as_business: "Logga in som företag",
      register: "Registrera",
      email: "E-post",
      password: "Lösenord",
      confirm_password: "Bekräfta lösenord",
      forgot_password: "Glömt lösenord?",
      reset_password_title: "Återställ lösenord",
      reset_password_desc: "Ange din e-postadress så skickar vi en länk för att återställa ditt lösenord.",
      send_reset_link: "Skicka återställningslänk",
      reset_email_sent: "Återställningslänk skickad till din e-post!",
      reset_email_error: "Fel vid lösenordsåterställning. Kontrollera e-postadressen.",
      enter_email: "Ange e-postadress",
      no_account: "Inget konto?",
      have_account: "Har du redan ett konto?",
      create_account: "Skapa konto",
      change_password: "Byt lösenord",

      // User types
      consumer: "Konsument",
      business: "Företag",
      select_user_type: "Välj användartyp",
      consumer_desc: "Hitta tjänster och gör bokningar",
      business_desc: "Erbjud tjänster och ta emot bokningar",

      // Navigation
      nav_home: "Hem",
      nav_discover: "Utforska",
      nav_profile: "Profil",
      nav_bookings: "Bokningar",
      nav_settings: "Inställningar",

      // Home
      welcome: "Välkommen",
      welcome_subtitle: "Boka snabbt – tjänsten vid din dörr på nolltid",
      business_welcome_subtitle: "Väx ditt företag med oss",
      featured_services: "Populära tjänster",
      how_it_works: "Så enkelt är det",
      step_1_title: "Välj tjänst",
      step_1_desc: "Bläddra bland kategorier och hitta rätt på sekunder",
      step_2_title: "Boka direkt",
      step_2_desc: "Välj en tid – bokningen tar under en minut",
      step_3_title: "Klart!",
      step_3_desc: "Proffset kommer till dig vid överenskommen tid",

      // Business Home
      why_use_app: "Varför använda Reserve?",
      benefit_customers_title: "Nå nya kunder",
      benefit_customers_desc: "Gör dina tjänster synliga och hitta nya kunder enkelt",
      benefit_bookings_title: "Automatiska bokningar",
      benefit_bookings_desc: "Bokningar hamnar direkt i din kalender utan extra arbete",
      benefit_growth_title: "Väx ditt företag",
      benefit_growth_desc: "Nå nya kunder och väx ditt företag",
      benefit_time_title: "Spara tid",
      benefit_time_desc: "Slut på att svara i telefon – allt sker automatiskt",
      stat_businesses: "Fler kunder",
      stat_bookings: "Mer synlighet",
      stat_rating: "Enkla bokningar",
      quick_actions: "Snabbåtgärder",
      manage_profile: "Hantera profil",
      edit_profile: "Redigera profil",
      view_bookings: "Visa bokningar",

      // Discovery
      discover_title: "Snabbbokning",
      no_businesses: "Inga tjänsteleverantörer tillgängliga",
      swipe_up: "Svep uppåt för att se mer",
      book_now: "Boka nu",
      view_calendar: "Se tillgänglighet",
      available: "Tillgänglig nu",
      select_category: "Vad behöver du?",
      select_category_description: "Välj en kategori och boka på sekunder",

      // Services/Categories
      all_services: "Alla tjänster",
      cleaning: "Städning",
      snow_removal: "Snöröjning",
      window_cleaning: "Fönsterputsning",
      gardening: "Trädgårdsarbete",
      moving: "Flyttjänst",
      handyman: "Hantverkare",
      other_service: "Annan tjänst",
      custom_service_type: "Egen tjänstetyp",
      custom_service_type_placeholder: "Skriv din egen tjänstetyp...",

      // Business Profile
      business_profile: "Företagsprofil",
      company_name: "Företagsnamn",
      company_name_placeholder: "Företag Ab",
      description: "Beskrivning",
      business_description_placeholder: "Berätta om ditt företag och vilka tjänster ni erbjuder...",
      services_offered: "Tjänster som erbjuds",
      add_service: "Lägg till tjänst",
      profile_image: "Profilbild",
      contact_info: "Kontaktuppgifter",
      contact_info_hint: "Lägg till minst telefon eller e-post",
      phone: "Telefon",
      address: "Adress",
      operating_area: "Verksamhetsområde",
      operating_area_placeholder: "t.ex. Helsingfors, Esbo",
      max_2_areas: "max 2",
      setup_business_profile: "Slutför din företagsprofil",
      setup_business_desc: "Fyll i grundläggande information om ditt företag för att komma åt appen",
      continue_to_app: "Fortsätt till appen",
      basic_info: "Grundläggande info",
      contact_email: "Kontakt-e-post",

      // Service Profiles
      service_profiles: "Tjänsteprofiler",
      create_service_profile: "Skapa tjänsteprofil",
      edit_service_profile: "Redigera tjänsteprofil",
      service_type: "Tjänstetyp",
      service_title: "Tjänstens titel",
      service_title_placeholder: "t.ex. Grundlig hemstädning",
      service_description: "Tjänstens beskrivning",
      service_description_placeholder: "Beskriv i detalj vad tjänsten inkluderar...",
      price: "Pris",
      duration: "Varaktighet",
      no_service_profiles: "Inga tjänsteprofiler ännu",
      create_first_service: "Skapa din första tjänsteprofil",
      service_created: "Tjänsteprofil skapad",
      service_updated: "Tjänsteprofil uppdaterad",
      service_deleted: "Tjänsteprofil borttagen",
      required_customer_fields_label: "Obligatoriska kunduppgifter",
      require_address: "Adress",
      require_phone: "Telefonnummer",
      require_email: "E-post",

      // Calendar & Booking
      calendar: "Kalender",
      booking_calendar: "Bokningskalender",
      select_date: "Välj datum",
      select_time: "Välj tid",
      available_slots: "Tillgängliga tider",
      booked: "Bokad",
      confirm_booking: "Bekräfta bokning",
      booking_confirmed: "Bokning bekräftad!",
      your_bookings: "Dina bokningar",
      upcoming_bookings: "Kommande bokningar",
      past_bookings: "Tidigare bokningar",
      no_bookings: "Inga bokningar",
      tap_to_toggle_availability: "Välj en dag för att ställa in tillgängliga tider",
      time_slots_available: "tider tillgängliga",
      add_available_time: "Lägg till tillgänglig tid",
      no_times_set: "Inga tider inställda för denna dag",
      confirm_changes: "Bekräfta ändringar",
      cancel_booking: "Avboka",
      cancellation_reason: "Avbokningsorsak",
      cancellation_reason_placeholder: "Berätta varför du avbokar...",
      rebook: "Boka ny tid",
      confirm_cancellation: "Bekräfta avbokning",
      booking_cancelled: "Bokning avbokad",
      free_times: "lediga tider",
      cancelled: "Avbokad",
      completed: "Utförd",
      rebook_confirmation_text: "Vill du boka en ny tid? Du kommer att omdirigeras till tjänstesökningen.",
      received_bookings: "Mottagna bokningar",
      manage_customer_bookings: "Hantera kundbokningar",
      customer_info: "Kunduppgifter",
      mark_completed: "Markera som utförd",
      contact_customer: "Kontakta kund",
      booking_completed: "Bokning markerad som utförd",
      unknown: "Okänd",
      confirm_service: "Bekräfta utförd",
      service_confirmed: "Tjänsten bekräftad som utförd",

      // Reviews
      leave_review: "Lämna en recension",
      review_placeholder: "Berätta om din upplevelse...",
      submit_review: "Skicka recension",
      review_submitted: "Recension skickad",
      review_error: "Fel vid sändning av recension",
      reviews: "Recensioner",
      no_reviews: "Inga recensioner ännu",
      anonymous_customer: "Anonym kund",
      average_rating: "Genomsnitt",
      show_all_reviews: "Visa alla recensioner ({{count}})",
      business_calendar: "Bokningskalender",
      bookings_for_day: "Bokningar för",
      no_bookings_for_day: "Inga bokningar för denna dag",
      cannot_complete_yet: "Tjänsten kan markeras som utförd först efter starttiden",

      // Chat
      chat_greeting: "Hej! Tack för att du kontaktade oss. Hur kan jag hjälpa dig idag?",
      chat_auto_response: "Tack för ditt meddelande! Vi återkommer så snart som möjligt.",
      type_message: "Skriv ett meddelande...",
      usually_responds_quickly: "Svarar vanligtvis snabbt",
      start_conversation: "Starta en konversation med {{name}} genom att skicka ett meddelande.",
      start_booking_conversation: "Starta en konversation om denna bokning",
      ask_about_booking: "Fråga om tjänstedetaljer eller andra bokningsrelaterade frågor.",
      message: "Meddelande",

      // Image Upload
      current_image: "Nuvarande bild",
      image_url: "Bild-URL",
      choose_sample: "Eller välj en exempelbild",
      image_updated: "Bild uppdaterad",
      upload_from_device: "Ladda upp från enhet",
      uploading: "Laddar upp...",
      invalid_file_type: "Ogiltig filtyp. Välj en bildfil.",
      file_too_large: "Filen är för stor (max 5 MB)",
      upload_error: "Bilduppladdning misslyckades",
      crop_image: "Beskär bild",
      zoom: "Zooma",
      confirm: "Bekräfta",

      // Categories
      add_new_category: "Lägg till ny kategori",
      new_category_placeholder: "Kategorinamn...",
      category_created: "Kategori skapad",
      category_exists: "Kategorin finns redan",

      // Settings
      settings: "Inställningar",
      account: "Konto",
      account_settings: "Kontoinställningar",
      language: "Språk",
      notifications: "Aviseringar",
      privacy: "Integritet",
      help: "Hjälp",
      about: "Om",
      logout: "Logga ut",
      delete_account: "Radera konto",
      confirm_logout_title: "Logga ut",
      confirm_logout_desc: "Är du säker på att du vill logga ut?",
      confirm_delete_title: "Radera konto",
      confirm_delete_desc: "Denna åtgärd kan inte ångras. Berätta varför du vill radera ditt konto.",
      reason_too_expensive: "För dyrt",
      reason_not_needed: "Behövs inte längre",
      reason_bad_experience: "Dålig upplevelse",
      reason_other: "Annan anledning",
      delete_reason_placeholder: "Berätta mer...",
      account_deleted: "Konto raderat",

      // Notifications settings
      push_notifications: "Push-aviseringar",
      push_notifications_desc: "Få aviseringar på din telefon",
      email_notifications: "E-postaviseringar",
      email_notifications_desc: "Få aviseringar via e-post",
      booking_reminders: "Bokningspåminnelser",
      booking_reminders_desc: "Påminnelse innan din bokade tid",
      message_notifications: "Meddelandeaviseringar",
      message_notifications_desc: "Avisering vid nya meddelanden",

      // Privacy settings
      profile_visibility: "Profilsynlighet",
      profile_visibility_desc: "Din profil är synlig för andra användare",
      show_location: "Visa plats",
      show_location_desc: "Din plats visas i din profil",
      allow_messages: "Tillåt meddelanden",
      allow_messages_desc: "Andra kan skicka meddelanden till dig",

      // Help
      faq: "Vanliga frågor",
      faq_desc: "Hitta svar på vanliga frågor",
      live_chat: "Livechatt",
      live_chat_desc: "Chatta med kundtjänst",
      email_support: "E-postsupport",
      email_support_desc: "reserve@app.fi",
      confirm_final_delete_title: "Är du helt säker?",
      confirm_final_delete_desc: "Denna åtgärd kan inte ångras. Ditt konto och alla tillhörande data raderas permanent.",
      confirm_delete_button: "Ja, radera mitt konto",
      account_delete_error: "Kontot kunde inte raderas. Försök igen.",

      // About
      legal: "Juridik",
      terms_of_service: "Användarvillkor",
      privacy_policy: "Integritetspolicy",

      // Terms acceptance
      accept_terms_title: "Acceptera villkor",
      accept_terms_desc: "Du måste acceptera följande villkor för att fortsätta.",
      accept_terms_checkbox: "Jag accepterar användarvillkoren",
      accept_privacy_checkbox: "Jag accepterar integritetspolicyn",
      accept_payment_terms_checkbox: "Jag accepterar betalningsvillkoren",
      read_terms: "Läs användarvillkoren",
      read_privacy: "Läs integritetspolicyn",
      read_payment_terms: "Läs betalningsvillkoren",
      accept_and_continue: "Acceptera och fortsätt",

      // Booking required fields
      fill_booking_details: "Fyll i obligatoriska uppgifter",
      your_address: "Din adress",
      your_phone: "Ditt telefonnummer",
      your_email: "Din e-post",

      // Messages
      success: "Lyckades!",
      error: "Fel",
      profile_updated: "Profil uppdaterad",
      booking_success: "Bokning lyckades",
      time_already_booked: "Denna tid är redan bokad. Välj en annan tid.",
      booking_error: "Bokning misslyckades",

      // Messages page
      messages: "Meddelanden",
      no_messages: "Inga meddelanden",
      no_messages_desc: "Dina konversationer med tjänsteleverantörer och kunder visas här.",
      service_messages: "Tjänstemeddelanden",
      general_messages: "Allmänna",
      no_service_messages_desc: "Tjänstemeddelanden visas här när du har aktiva bokningar.",
      no_general_messages_desc: "Inga allmänna meddelanden ännu.",
      chat_closed: "Chatten är stängd",
      browse_without_login: "Bläddra bland tjänster utan att logga in",
      nav_messages: "Meddelanden",
      cancellation_error: "Avbokning misslyckades",
      past_date_warning: "Kan inte lägga till tider för passerade datum",

      // Business Public Profile
      view_profile: "Visa profil",
      all_services_by: "Alla tjänster",
      business_info: "Företagsinfo",
      services_count: "tjänster",
      no_services_available: "Inga tjänster tillgängliga",
      no_messages_in_conversation: "Inga meddelanden i denna konversation ännu.",
      customer: "Kund",

      // Auth errors
      login_error: "Inloggning misslyckades. Kontrollera e-post och lösenord.",
      register_error: "Registrering misslyckades. Försök igen.",
      email_already_registered: "E-posten är redan registrerad.",
      registration_success: "Registrering lyckades! Kontrollera din e-post för att verifiera ditt konto.",
      auth_error: "Ett fel uppstod. Försök igen.",

      // Subscription
      subscription_required_title: "Reserve Business-prenumeration",
      subscription_required_desc: "Starta din 30 dagars gratis provperiod",
      month: "mån",
      trial_info: "30 dagar gratis",
      feature_unlimited_services: "Obegränsat antal tjänster",
      feature_calendar_management: "Kalenderhantering",
      feature_customer_messaging: "Kundmeddelanden",
      feature_booking_system: "Bokningssystem",
      feature_analytics: "Analys och rapporter",
      card_required_note: "Kortuppgifter krävs för att starta provperioden",
      start_trial: "Starta gratis provperiod",
      subscription_error: "Fel vid start av prenumeration",
      subscription: "Prenumeration",
      trial_active: "Provperiod aktiv",
      subscription_active: "Prenumeration aktiv",
      no_subscription: "Ingen prenumeration",
      admin_access: "Administratörsåtkomst",
      portal_error: "Fel vid hantering av prenumeration",
      iframe_warning_title: "Observera i redigeringsförhandsgranskning",
      iframe_warning_desc: "Betalningen öppnas i en ny flik. Inloggningsstatus kanske inte kvarstår mellan flikar. Rekommendation: öppna appen i en ny flik först.",
      open_in_new_tab: "Öppna i ny flik",

      // Booking requests
      propose_time: "Föreslå en tid",
      propose_time_desc: "Föreslå din önskade tid till företaget. De kan acceptera eller avvisa.",
      proposed_time: "Föreslagen tid",
      your_message: "Ditt meddelande (valfritt)",
      booking_requests: "Tidsförslag",
      pending_requests: "Väntande förslag",
      accept: "Acceptera",
      reject: "Avvisa",
      rejection_reason: "Avvisningsorsak",
      request_accepted: "Förslag accepterat",
      request_rejected: "Förslag avvisat",
      request_sent: "Tidsförslag skickat",
      request_pending: "Väntar",
      request_status_accepted: "Accepterat",
      request_status_rejected: "Avvisat",
      send: "Skicka",
      no_requests: "Inga tidsförslag",
      your_requests: "Dina förslag",

      // Calendar batch
      select_multiple_days: "Välj flera dagar",
      add_time_range: "Lägg till tidsintervall",
      start_time: "Starttid",
      end_time: "Sluttid",
      interval_minutes: "Intervall (min)",
      clear_all_slots: "Rensa alla tider",
      add_range_to_selected: "Lägg till tider för valda dagar",
      selected_days: "valda dagar",

      // Business registration
      business_registration_disabled: "Det går inte att skapa ett företagskonto via registrering.",
      contact_for_business_account: "Kontakta reserve@app.fi för att skapa ett företagskonto.",

      // Legal page titles
      consumer_terms_title: "Konsumentvillkor",
      business_terms_title: "Företagsvillkor",
      consumer_privacy_title: "Konsumentens integritetspolicy",
      business_privacy_title: "Företagets integritetspolicy",

      // Consumer terms
      ct_platform_role_title: "1. Plattformens roll",
      ct_platform_role_desc: "Plattformen fungerar enbart som förmedlare mellan konsumenter och tjänsteleverantörer. Plattformen tillhandahåller inte tjänster själv och är inte part i tjänsteavtalet.",
      ct_service_delivery_title: "2. Tjänsteleverans",
      ct_service_delivery_desc: "Tjänsteleverantörer är oberoende aktörer. Plattformen ansvarar inte för tjänstekvalitet, prissättning eller resultat.",
      ct_booking_title: "3. Bokning",
      ct_booking_desc: "Konsumenten gör bokningar direkt med tjänsteleverantören via plattformen. Avbokningar och ändringar avtalas med tjänsteleverantören.",
      ct_liability_title: "4. Ansvarsbegränsning",
      ct_liability_desc: "Plattformen ansvarar inte för skador, förseningar eller tvister mellan tjänsteleverantören och konsumenten.",

      // Business terms
      bt_independent_operator_title: "1. Oberoende aktör",
      bt_independent_operator_desc: "Tjänsteleverantören verkar som en oberoende företagare eller privat tjänsteleverantör. Plattformen är inte arbetsgivare, mäklare eller uppdragsgivare.",
      bt_responsibility_title: "2. Ansvar",
      bt_responsibility_desc: "Tjänsteleverantören ansvarar för:",
      bt_responsibility_quality: "Tjänstens innehåll och kvalitet",
      bt_responsibility_legality: "Laglighet",
      bt_responsibility_taxes: "Skatter och bokföring",
      bt_responsibility_insurance: "Försäkringar",
      bt_customers_title: "3. Kunder",
      bt_customers_desc: "Plattformen garanterar inte kundvolym eller försäljning. Plattformen tillhandahåller enbart synlighet och en bokningsplattform.",
      bt_account_removal_title: "4. Borttagning av konto",
      bt_account_removal_desc: "Plattformen förbehåller sig rätten att ta bort en tjänsteleverantör som bryter mot användarvillkoren eller agerar olagligt.",

      // Privacy pages
      privacy_we_collect: "Vi samlar in",
      privacy_data_used_for: "Data används för",
      privacy_collect_email: "E-postadress",
      privacy_collect_account: "Användarkontoinformation",
      privacy_collect_usage: "Applikationsanvändningsdata",
      privacy_use_service: "Tillhandahållande av tjänsten",
      privacy_use_communication: "Kundkommunikation",
      privacy_use_development: "Tjänsteutveckling",
      privacy_no_sell: "Data säljs inte till tredje part.",
      privacy_collect_business_profile: "Företagsprofilinformation",
      privacy_collect_contact: "Kontaktuppgifter",
      privacy_collect_technical: "Teknisk användningsdata",
      privacy_use_connections: "Möjliggöra kundkontakter",
      privacy_use_billing: "Fakturering",

      // Complaints
      file_complaint: "Lämna klagomål",
      complaint_desc: "Om företaget inte levererade tjänsten enligt avtal kan du lämna ett klagomål. Vi hanterar det så snart som möjligt.",
      complaint_placeholder: "Berätta vad som hände och varför du vill lämna ett klagomål...",
      send_complaint: "Skicka klagomål",
      complaint_sent: "Klagomål skickat. Vi hanterar det snart.",

      // District
      operating_district: "Stadsdel",
      operating_district_placeholder: "t.ex. Kallio, Tölö",

      // Availability types
      anytime: "Vilken tid som helst",
      anytime_desc: "Kunden kan föreslå vilken tid som helst",
      blocked: "Ej tillgänglig",
      blocked_desc: "Dagen är blockerad och inga bokningar kan göras",
      specific_times: "Specifika tider",
      select_date_range: "Välj datumintervall",
      availability_type: "Tillgänglighetstyp",
      choose_availability_or_times: "Välj en tillgänglighetstyp eller lägg till specifika tider nedan",
      or: "eller",
      apply_to_range: "Tillämpa på valda dagar",
      anytime_set_success: "Dagar inställda: vilken tid som helst",
      blocked_set_success: "Dagar inställda: ej tillgänglig",
      propose_your_time: "Föreslå din önskade tid",
      day_blocked: "Denna dag är inte tillgänglig",
      color_legend: "Färgförklaring",
      anytime_available: "Vilken tid som helst tillgänglig",
      specific_slots_available: "Specifika tider",
      today_marker: "Idag",
      unsaved_changes: "Osparade ändringar",
      changes_saved: "Ändringar sparade",
      book_directly: "Boka direkt",
      selected_marker: "Vald",
      no_slots_propose: "Inga lediga tider – du kan föreslå en tid",

      // Booking limits
      max_daily_bookings: "Max bokningar per dag",
      buffer_minutes: "Paus mellan bokningar",
      pick_any_time: "Välj vilken tid som helst",
      day_full: "Dagen full",
      bookings_remaining: "bokningar kvar",
      no_limit: "Ingen gräns",

      // Password reset page
      set_new_password_title: "Ange nytt lösenord",
      set_new_password_desc: "Ange ditt nya lösenord nedan.",
      new_password: "Nytt lösenord",
      password_updated: "Lösenord uppdaterat!",
      passwords_dont_match: "Lösenorden matchar inte",
      password_update_error: "Lösenordsuppdatering misslyckades",
      password_too_short: "Lösenordet måste vara minst 6 tecken",
      back_to_login: "Tillbaka till inloggning",

      // Registration terms
      accept_terms_register: "Jag accepterar användarvillkoren",
      accept_privacy_register: "Jag accepterar integritetspolicyn",

      // Discovery tabs & business browse
      tab_services: "Tjänster",
      tab_businesses: "Företag",
      browse_businesses_title: "Bläddra bland företag",
      browse_businesses_desc: "Utforska företag och deras tjänster",
      no_businesses_found: "Inga företag tillgängliga",
      all_services_count: "{{count}} tjänster",
      send_message: "Skicka meddelande",
    }
  }
};
